<div class="c-formn-validation-messages" *ngIf="getMessages().length > 0">
  <div class="msg-container" *ngFor="let message of getMessages()">
    <i class="m-fi "
       [ngClass]="'m-fi--exclamation-on-circle'"></i>
    <span>{{message}}</span>
  </div>
</div>
